import { AnchorHTMLAttributes } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import cls from 'classnames';

import styles from './Link.module.css';

export const REGULAR = 'regular';
export const NAV = 'nav';
export const NONE = 'none';

const CLASS_MAP = {
  [REGULAR]: styles.link,
  [NAV]: styles.nav,
  [NONE]: '',
};

export type LinkAppearance = keyof typeof CLASS_MAP;

interface LinkProps extends Record<string, unknown> {
  to?: Nullable<string>;
  href?: Nullable<string>;
  className?: string;
  activeClassName?: string;
  exact?: boolean;
  appearance?: LinkAppearance;
  external?: boolean;
}

function Link(props: LinkProps) {
  const {
    appearance = REGULAR,
    external = false,
    to = null,
    href = null,
    className,
    activeClassName,
    exact = false,
    ...rest
  } = props;

  const newProps: Record<string, unknown> = { ...rest, href };

  if (external) {
    newProps.target = '_blank';
  }

  const linkClassName = cls(CLASS_MAP[appearance], className);

  if (to) {
    return (
      <NavLink
        {...(newProps as unknown as NavLinkProps)}
        to={to}
        end={exact}
        className={({ isActive }) => cls(linkClassName, isActive && activeClassName)}
      />
    );
  }

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a {...(newProps as AnchorHTMLAttributes<HTMLAnchorElement>)} className={linkClassName} />;
}

export default Link;
